import type { WebhookDelivery, WebhookSubscription } from 'src/interfaces/webhook'
import type { State } from '../reducers/types'

/**
 * Returns the stored array by reference. Never build a new array or object literal in a
 * selector — every consuming `useSelector` would re-render on each dispatch. Sorting and
 * filtering belong in the component under `useMemo`.
 */
export const getWebhookSubscriptions = (state: State): WebhookSubscription[] => {
  return state.webhook.subscriptions
}

export const getWebhookSubscriptionsLoading = (state: State): boolean => {
  return state.webhook.subscriptionsLoading
}

export const getWebhookSubscriptionsError = (state: State): string | null => {
  return state.webhook.subscriptionsError
}

export const getWebhookSaving = (state: State): boolean => {
  return state.webhook.saving
}

export const getWebhookDeliveries = (state: State): WebhookDelivery[] => {
  return state.webhook.deliveries
}

export const getWebhookDeliveriesTotal = (state: State): number => {
  return state.webhook.deliveriesTotal
}

export const getWebhookDeliveriesLoading = (state: State): boolean => {
  return state.webhook.deliveriesLoading
}

export const getWebhookDeliveriesError = (state: State): string | null => {
  return state.webhook.deliveriesError
}

export const getWebhookSending = (state: State): boolean => {
  return state.webhook.sending
}
